"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _forEach = _interopRequireDefault(require("lodash/forEach"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(obj) {
  var str = '';
  (0, _forEach["default"])(obj, function (value, key) {
    if (value === undefined || value === null) return;
    str += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
  });
  return str.substring(1);
}

module.exports = exports.default;